<script setup lang="ts">
import { RotateCcw } from 'lucide-vue-next'

defineProps<{
  label: string
}>()

const emit = defineEmits<{
  click: []
}>()
</script>

<template>
  <AppTooltip :text="label">
    <Button type="button" variant="ghost" size="icon-sm" :aria-label="label" @click="emit('click')">
      <RotateCcw />
    </Button>
  </AppTooltip>
</template>
